import { gql } from '@apollo/client';

export const CREATE_COUNTRY_LANGUAGE_MUTATION = gql`
  mutation createCountryLanguage(
    $countryId: Int!
    $languageIds: [Int!]!
  ) {
    createCountryLanguage(
      countryId: $countryId
      languageIds: $languageIds
    ) {
      countryLanguage {
        id
      }
    }
  }
`;

export const UPDATE_COUNTRY_LANGUAGE_MUTATION = gql`
  mutation editCountryLanguage(
    $id: Int!
    $countryId: Int!
    $languageIds: [Int!]!
  ) {
    editCountryLanguage(
      id: $id
      countryId: $countryId
      languageIds: $languageIds
    ) {
      countryLanguage {
        id
      }
    }
  }
`;
